import React, { useState } from "react";
import "../../../../../css/CashflowModeller2/Inputs/ButtonBig.css";
import { ReactComponent as TooltipIcon } from "../../../../../assets/icons/question-mark-tooltip.svg";
import { ReactComponent as InfoIcon } from "../../../../../assets/icons/info.svg";
import TooltipBox from "../Tooltips/TooltipBox";

/**
 * Renders a large button component with optional tooltip functionality.
 *
 * @component
 * @param {Object} props - The props for ButtonBig.
 * @param {string} props.buttonText - The text to display on the button.
 * @param {boolean} props.isActive - Determines if the button is in an active (clicked) state.
 * @param {function} props.onClick - Callback function to handle button click events.
 * @param {boolean} props.disabled - If true, disables the button.
 * @param {boolean} [props.showTooltip=false] - If true, displays a tooltip icon and content on hover.
 * @param {React.ReactNode} props.children - The content to display inside the tooltip.
 * @returns {JSX.Element} The rendered ButtonBig component.
 */
const ButtonBig = ({
  buttonText,
  isActive,
  onClick,
  disabled,
  showTooltip = false,
  children,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="tooltip-button-wrapper">
      <div
        className={`ButtonBig ${isActive ? "clicked" : ""} ${
          disabled ? "disabled" : ""
        }`}
        onClick={onClick}
      >
        <div className="Title">{buttonText}</div>
        {showTooltip && (
          <div
            style={{ position: "relative", display: "inline-block" }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
          >
            <InfoIcon />
            {hovered && <TooltipBox>{ children}</TooltipBox>}
          </div>
        )}

        {/* {hovered && showTooltip && <TooltipBox>{children}</TooltipBox>} */}
      </div>
    </div>
  );
};

export default ButtonBig;
